export default "__VITE_ASSET__3EoDN$$M__"